import { postCall } from 'sharedKernel/api'
import { PUBLIC_MEETING_ROOM_API } from './constants'

export interface ICancelPublicReservationPayload {
  reservationCode: string
  email: string
}

export const cancelPublicReservation = async (
  payload: ICancelPublicReservationPayload
): Promise<void> => {
  await postCall({
    url: PUBLIC_MEETING_ROOM_API.CANCEL_RESERVATION,
    isPublic: true,
    data: payload,
  })
}
